export default function navigation() {

  // quick jquery

  $('.menu-icon').on('click', function() {
    $(this).toggleClass('is-active');
    $('html').toggleClass('locked');
    $('body').toggleClass('locked');
  });

  // Mobile submenu toggle
  const mobileItems = document.querySelectorAll('.mobile-menu-item');

  mobileItems.forEach(item => {
    const toggle = item.querySelector('.submenu-toggle');
    if (!toggle) return;

    toggle.addEventListener('click', e => {
      e.preventDefault();
      item.classList.toggle('open');
      const submenu = item.querySelector('.mobile-submenu');
      if (submenu) submenu.classList.toggle('open');
    });
  });

  // Optional: desktop arrow hover sync
  const desktopItems = document.querySelectorAll('.menu-item.has-dropdown, .menu-item.has-mega');
  desktopItems.forEach(item => {
    const arrow = item.querySelector('.menu-arrow');
    if (!arrow) return;
    item.addEventListener('mouseenter', () => arrow.classList.add('open'));
    item.addEventListener('mouseleave', () => arrow.classList.remove('open'));
  });
}
